import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { portalCfg } from '../../config';
import Loading from '../../components/CustomLoading';
import ModalConfirm from '../../components/CustomModal';
import crmservices from '../../services/wsclients';
import InvoicesView from './InvoicesView';
import { formatDateToMMYYYY, formatPeriodDate, getPeriodDate, statementPeriodOption } from '../../utils/util';
import InvoiceDetailView from './InvoiceDetailView';
import moment from 'moment';
import { printHtml, tempInvoice, tempItemInvoice } from '../../utils/printUtil';
import CustomAlert from '../../components/CustomAlert';
import { formatDateToDDMMYYYYFrEpoch, getCurrency } from '../../utils/commons';
import wsclients from '../../services/wsclients';

export default function InvoicesController(props) {
    const { t } = useTranslation();

    const [showLoading, setShowLoading] = useState(false);
    const [accountFinance, setAccountFinance] = useState({});
    const [wallet, setWallet] = useState({});
    const [confirm, setConfirm] = useState({});
    const [invoices, setInvoices] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [showLoadMore, onShowLoadMore] = useState(false);
    const [primaryCard, setSrimaryCard] = useState(null);
    const [listPeriods, setListPeriods] = useState([
        {
            value: statementPeriodOption.THIS_MONTH,
            label: 'This Month'
        },
        {
            value: statementPeriodOption.LAST_MONTH,
            label: 'Last Month'
        },
        {
            value: statementPeriodOption.THIS_YEAR,
            label: 'This Year'
        },
        {
            value: statementPeriodOption.LAST_YEAR,
            label: 'Last Year'
        },
        {
            value: statementPeriodOption.SPECIFIC_PERIOD,
            label: 'Specific Period'
        },
    ]);
    const [periodSeleted, setPeriodSeleted] = useState(statementPeriodOption.THIS_MONTH);
    const [error, setError] = useState({});
    const [contact, setContact] = useState({});
    const [params, setParams] = useState({
        from_date: formatPeriodDate(getPeriodDate('START_OF_' + statementPeriodOption.THIS_MONTH)),
        to_date: formatPeriodDate(getPeriodDate('END_OF_' + statementPeriodOption.THIS_MONTH)),
        transaction_type: 'INVOICE',
    });
    const [specificPeriod, setSecificPeriod] = useState({
        from_date: formatDateToMMYYYY(getPeriodDate('START_OF_' + statementPeriodOption.THIS_MONTH)),
        to_date: formatDateToMMYYYY(getPeriodDate('END_OF_' + statementPeriodOption.THIS_MONTH)),
    });
    const [paging, setPaging] = useState(null);
    const [showDetailInvoice, setShowDetailInvoice] = useState(false);
    const [showPrintout, setShowPrintout] = useState(false);
    const [invoiceDetail, setInvoiceDetail] = useState(null);
    const [transactionTypes, setTransactionTypes] = useState([
        {
            value: 'INVOICE',
            label: t('invoice'),
        },
        {
            value: 'PAYMENT',
            label: t('payment'),
        }
    ]);
    const [showFormAmount, setShowFormAmount] = useState(false);
    const [amount, setAmount] = useState(null);
    const [contactPhone, setContactPhone] = useState(null);

    const currency = getCurrency() ? getCurrency() : portalCfg.default_currency;

    const cells = [
        {
            id: 'number',
            name: t('invoice_number')
        },
        {
            id: 'due_date',
            name: t('due_date')
        },
        {
            id: 'date',
            name: t('date_title')
        },
        {
            id: 'transaction_type',
            name: t('transaction_type')
        },
        {
            id: 'amount',
            name: t('invoice_amount'),
            align: 'right'
        },
        {
            id: 'unpaid_amount',
            name: t('unpaid_amount'),
            align: 'right'
        },
    ];

    useEffect(() => {
        onLoad();
    }, []);

    const onLoad = async () => {
        setShowLoading(true);
        await onLoadWallet();
        await onLoadAccountJournals();
        await onLoadContact();
        await onLoadPhone();
        getPrimaryCard();
        setShowLoading(false);
    }

    const onLoadWallet = async () => {
        try {
            let result = await crmservices.account.getWalletInfo();
            console.log("AAAAAA load wallet:", result);
            if (result.code === 'OK') {
                setAccountFinance(result.data ? result.data : {});
                setWallet(result.data.wallet ? result.data.wallet : {});
            }
        } catch (error) {
            console.log("load wallet error:", error);
        }
    }

    const onLoadContact = async () => {
        try {
            var result = await crmservices.contacts.getContact();
            if (result.code === 'OK') {
                setContact(result.data)
            }
        } catch (error) {
            console.log("load contact error:", error);
        }
    }

    const onLoadPhone = async () => {
        try{            
            var result = await wsclients.contacts.getPhones();
            console.log('onLoadPhone result: ', result)
            if(result.code == 'OK'){
                var content = result.data.content && result.data.content.length > 0 ? result.data.content[0] : null;
                if(content) setContactPhone(content);
            }
        }catch(ex){
            console.log("onLoadPhone exception: ", ex);
        }
    }

    const onPrintInvoice = () => {

    }

    const onPay = async () => {
        setShowLoading(true);
        try {
            let isCheckAmount = onValidateAmount(amount);
            if (isCheckAmount) {
                if (primaryCard) {
                    const result = await crmservices.paymentgateway.createIntent({
                        payment_gateway: "JCC",
                        integration_id: document._portalConfig.paygateIntegrationId,
                        payment_method_id: primaryCard.id,
                        amount: amount,
                        currency: accountFinance.currency_code
                    });
                    if (result.code == 'OK' && result.data && result.data.client_secret) {
                        setShowFormAmount(false);
                        const resultConfirm = await crmservices.paymentgateway.payment({
                            client_secret: result.data.client_secret,
                            payment_method: {
                                id: primaryCard.id,
                                type: 'CARD',
                            },
                            amount: amount,
                            currency: accountFinance.currency_code
                        });
                        console.log('resultConfirm: ', resultConfirm)
                        if (resultConfirm.code === 'OK') {
                            //onLoadWallet();
                            await onLoad();
                            showAlert(t('PAYMENT_SUCCESS'));
                        } else {
                            showAlert(t('PAYMENT_FAILED'));
                        }
                    } else {
                        showAlert(t('PAYMENT_FAILED'));
                    }
                } else {
                    showAlert(t('CARD_NOT_FOUND'));
                }
            }
        } catch (ex) {
            console.log("onPayMayaTopup ex:", ex)
            showAlert(t('EXCEPTION_PROCESS'));
        }
    }

    const getPrimaryCard = async () => {
        try {
            var result = await crmservices.contacts.getListPaymentMethods();
            //console.log("onLoadPaymentMethods result==", result);
            if (result.code == 'OK') {
                let cards = result.data.content ? result.data.content : [];
                let primaryCards = cards.filter(c => {
                    return c.is_primary
                })
                if (primaryCards && primaryCards.length > 0) {
                    setSrimaryCard(primaryCards[0]);
                }
            }
        } catch (error) {
            console.log("on load payment method exception:", error);
        }
    }

    const showAlert = (message) => {
        setShowLoading(false);
        setError({
            showAlert: true,
            message: message,
        });
    }

    const onCloseAlert = () => {
        setShowLoading(false);
        setError({
            showAlert: false,
            message: '',
        });
    }

    const onSelectPeriod = (event) => {
        setPeriodSeleted(event.target.value);
    }

    const onLoadAccountJournals = async (newParams) => {
        try {
            console.log("newParams==", newParams);
            let result = await crmservices.account.getAccountJournals(newParams ? newParams : params);
            console.log("AAAAAA load getAccountJournals:", result);
            if (result.code === 'OK') {
                setInvoices(result.data.content);
                setPaging(result.data.paging);
            }
        } catch (error) {
            console.log("load getAccountJournals error:", error);
        }
    }

    const handleChangePage = async (event, newPage) => {
        console.log("newPage ===", newPage);
        try {
            onShowLoadMore(true);
            setPaging({
                ...paging,
                page: newPage + 1,
            });
            let newParams = {
                ...params,
                page: newPage + 1,
            };
            setParams(newParams);
            await onLoadAccountJournals(newParams);
            onShowLoadMore(false);
        }
        catch (ex) {
            console.log("load next page handleChangePage==", ex);
        }
    };

    const onChangeType = async (type) => {
        let newParams = {
            ...params,
            transaction_type: type,
        }
        setParams(newParams);
        // await onLoadAccountJournals(newParams);
    }

    const onFilter = async (values) => {
        console.log("values form: ", values);
        setShowLoading(true);
        const { from_date, to_date, transaction_type } = values;
        let newParams = { ...params };
        newParams.transaction_type = transaction_type;
        setParams(newParams);
        if (periodSeleted != statementPeriodOption.SPECIFIC_PERIOD) {
            let fromDate = getPeriodDate('START_OF_' + periodSeleted);
            let toDate = getPeriodDate('END_OF_' + periodSeleted);
            console.log("fromDate==" + fromDate + ", toDate===" + toDate);
            newParams.from_date = formatPeriodDate(fromDate);
            newParams.to_date = formatPeriodDate(toDate);
        } else {
            let fromDate = typeof from_date == 'object' ? new Date(from_date.format("YYYY/MM/DD")) : new Date(formatDateDDMMYYYY("01/" + from_date));
            let toDate = '';
            if(typeof to_date === 'object') {
                let newDate = new Date(to_date.format("YYYY/MM/DD"));
                let d = new Date(newDate.getFullYear(), newDate.getMonth() + 1, 0);
                let b = d.getDate() + "/" + (d.getMonth() < 10 ? "0" + (d.getMonth() + 1) : d.getMonth) + "/" + d.getFullYear();
            
                toDate = new Date(formatDateDDMMYYYY(b));
            }
            else if(!to_date){
                let dayStr = '30';
                let toDateStr = specificPeriod.to_date.split("/");
                let toMonth = toDateStr[0];
                let toYear = toDateStr[1];
                let prefixMonth = 0;
                if(toMonth === "02") {
                    let d = new Date(toYear, prefixMonth + 2, 0);
                    dayStr = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
                } else {
                    let d = new Date(toYear, toMonth, 0);
                    dayStr = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
                }
                console.log("dayStr: ", dayStr)
                toDate = new Date(formatDateDDMMYYYY(dayStr + "/" + specificPeriod.to_date));
            }
            newParams.from_date = formatPeriodDate(fromDate);
            newParams.to_date = formatPeriodDate(toDate);
        }
        console.log("newParams===", newParams);
        setParams(newParams);
        await onLoadAccountJournals(newParams);
        setShowLoading(false);
    }

    const onDetailInvoice = async (invoice) => {
        setShowLoading(true);
        try {
            setInvoiceDetail(invoice);
            let result = await crmservices.account.getJournal(invoice.id);
            console.log("AAAAAA load onDetailInvoice:", result);
            if (result.code === 'OK') {
                setInvoiceDetail(result.data);
                setShowDetailInvoice(true);
            }
        } catch (error) {
            console.log("load onDetailInvoice error:", error);
        }
        setShowLoading(false);
    }

    const onPrint = async (entity_id) => {
        setShowLoading(true);
        try {
            // setShowPrintout(true);
            var content = tempInvoice;
            // content = content.replaceAll("#CONTACT_CODE", contact.code);
            //company name
            let contactName = contact.first_name + " " + contact.last_name;
            if(contact.type !== 'PERSON'){
                contactName = contact.company_name;
            }
            content = content.replaceAll("#CONTACT_NAME", contactName);
            let contact_phone = '';
            if(contactPhone){
                contact_phone += "0" + contactPhone.number;
            }
            content = content.replaceAll("#CONTACT_PHONE", contact_phone);
            // content = content.replaceAll("#VAT_NUMBER", currency + invoiceDetail.tax.toFixed(2));
            //billing address
            if(accountFinance && accountFinance.billing_address){
                let billingAddress = `<p>${accountFinance.billing_address.address_line_1}</p>`;
                billingAddress += `<p>${accountFinance.billing_address.town_city}</p>`;
                billingAddress += `<p>${accountFinance.billing_address.postal_code}</p>`;
                content = content.replaceAll("#BILLING_ADDRESS", billingAddress);
            } else {
                content = content.replaceAll("#BILLING_ADDRESS", '');
            }

            content = content.replaceAll("#INVOICE_NUMBER", invoiceDetail.number);
            if(invoiceDetail.posted_date) content = content.replaceAll("#INVOICE_DATE", formatDateToDDMMYYYYFrEpoch(invoiceDetail.posted_date, true));
            if(invoiceDetail.invoice && invoiceDetail.invoice.due_date) content = content.replaceAll("#INVOICE_DUE_DATE", formatDateToDDMMYYYYFrEpoch(invoiceDetail.invoice.due_date, true));
            content = content.replaceAll("#TOTAL_NET_AMOUNT", currency + invoiceDetail.net.toFixed(2));
            content = content.replaceAll("#TOTAL_DISCOUNT_AMOUNT", currency + invoiceDetail.discount.toFixed(2));
            content = content.replaceAll("#TOTAL_TAX_AMOUNT", currency + invoiceDetail.tax.toFixed(2));
            content = content.replaceAll("#TOTAL_AMOUNT", currency + invoiceDetail.total.toFixed(2));
            content = content.replaceAll("#OVERDUE_AMOUNT", currency + invoiceDetail.invoice.overdue_amount.toFixed(2));

            var itemContent = "";
            if (invoiceDetail.lines && invoiceDetail.lines.length > 0) {
                invoiceDetail.lines.map(item => {
                    var row = tempItemInvoice;

                    row = row.replaceAll("#PRODUCT_NAME", item.product.name);
                    row = row.replaceAll("#QUANTITY", item.quantity);
                    row = row.replaceAll("#PRICE", currency + item.unit_price.toFixed(2));
                    row = row.replaceAll("#DISCOUNT", currency + item.discount.toFixed(2));
                    row = row.replaceAll("#SUB_TOTAL", currency + item.net.toFixed(2));
                    row = row.replaceAll("#DESCRIPTION", item.product.description ? item.product.description : "");
                    itemContent = itemContent + row;
                })
            }
            content = content.replaceAll("#ITEM_INFO", "" + itemContent);
            console.log("printHtml content: ", content);
            printHtml(content);
        } catch (error) {
            console.log("onPrint error:", error);
        }
        setShowLoading(false);
    }

    const onConfirmPay = () => {
        setShowFormAmount(true);
    }

    const onChangeAmount = (value) => {
        if (value) {
            setAmount(value);
        }
    }

    const onValidateAmount = (value) => {
        console.log("value===", value);
        let validate = false;
        let balance = accountFinance && accountFinance.balance ? accountFinance.balance : 0;
        let amount = Number(value);
        if (amount > balance) {
            validate = false;
            showAlert(t('amount_less_equal_than') + balance + "!");
        } else if (amount <= 0) {
            validate = false;
            showAlert(t('amount_greater_than'));
        }
        else {
            validate = true;
        }
        return validate;
    }

    return (
        <>
            <InvoicesView
                currency={currency}
                wallet={wallet}
                accountFinance={accountFinance}
                rows={invoices}
                cells={cells}
                hasMore={hasMore}
                showLoadMore={showLoadMore}
                listPeriods={listPeriods}
                periodSeleted={periodSeleted}
                paging={paging}
                params={params}
                specificPeriod={specificPeriod}
                transactionTypes={transactionTypes}
                showFormAmount={showFormAmount}
                contact={contact}
                onChangeAmount={onChangeAmount}
                onConfirmPay={onConfirmPay}
                onPrintInvoice={onPrintInvoice}
                onPay={onPay}
                onFilter={onFilter}
                onSelectPeriod={onSelectPeriod}
                handleChangePage={handleChangePage}
                onDetailInvoice={onDetailInvoice}
                onChangeType={onChangeType}
                setParams={setParams}
                setShowFormAmount={setShowFormAmount}
            />
            {showLoading && <Loading open={showLoading} />}
            {confirm && <ModalConfirm
                open={confirm.show}
                onClose={() => setConfirm({})}
                message={confirm.message}
                confirm={confirm.actionTitle}
            />}
            <CustomAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                showButtonClose={true}
            />
            {showDetailInvoice && <InvoiceDetailView
                open={showDetailInvoice}
                item={invoiceDetail}
                currency={currency}
                onClose={() => setShowDetailInvoice(false)}
                onPrint={onPrint}
            />}
        </>
    );
}

function formatDateDDMMYYYY(date) {
    var dateMomentObject = moment(date, "DD/MM/YYYY"); // 1st argument - string, 2nd argument - format
    var dateObject = dateMomentObject.toDate();
    return dateObject;
}
